import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.find";
import { Children } from 'react';
import { toArray } from "./collections";

var hasChildren = function hasChildren(child) {
  return Boolean(child && child.props && child.props.children);
};

var hasComplexChildren = function hasComplexChildren(child) {
  return hasChildren(child) && typeof child.props.children === 'object';
};

export var findDeep = function findDeep(children, finder) {
  return Children.toArray(children).find(function (child) {
    return hasComplexChildren(child) ? findDeep(child.props.children, finder) : finder(child);
  });
};
export function findByType(children, type) {
  var match;
  Children.forEach(children, function (child) {
    if (!match && child && child.type === type) {
      match = child;
    }
  });
  return match;
}
export function findAllByType(children, type) {
  return Children.map(children, function (child) {
    if (child && child.type === type) {
      return child;
    }
  });
}
export function excludeByType(children, type) {
  var types = toArray(type);
  return Children.map(children, function (child) {
    if (types.indexOf(child.type) === -1) {
      return child;
    }
  });
}